<ng-template #bookForOtherModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{ title | translate }}</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="otherUserDetaisForm">
        <div class="row">
          <div class="col-sm-6 mb-3 pe-2">
            <label for="first-name" class="form-label">{{ "label-title.first-name" | translate }} </label>
            <input type="text" class="form-control" id="other-user-first-name" placeholder="{{ 'label-title.enter-first-name' | translate }}" formControlName="firstName" />
            @if (firstNameInput?.invalid && firstNameInput?.touched) {
            <div class="invalid-message">
              @if (firstNameInput?.hasError('required')) {
              <p class="m-0">{{ "label-title.first-name" | translate }} {{ "label-title.is-required" | translate }}</p>
              }
            </div>
            }
          </div>
          <div class="col-sm-6 mb-3 ps-2">
            <label for="last-name" class="form-label">{{ "label-title.last-name" | translate }} </label>
            <input type="text" class="form-control" id="other-user-last-name" placeholder="{{ 'label-title.enter-name' | translate }}" formControlName="lastName" />
            @if (lastNameInput?.invalid && lastNameInput?.touched) {
            <div class="invalid-message">
              @if (lastNameInput?.hasError('required')) {
              <p class="m-0">{{ "label-title.last-name" | translate }} {{ "label-title.is-required" | translate }}</p>
              }
            </div>
            }
          </div>

          <div class="col-lg-12">
            <div class="mb-3">
              <label for="email" class="form-label">{{ "label-title.email" | translate }}</label>
              <input type="text" class="form-control" id="other-user-email" placeholder="{{ 'label-title.enter-email' | translate }}" formControlName="email" />
              @if (emailInput?.invalid && emailInput?.touched) {
              <div class="invalid-message">
                @if (emailInput?.hasError('required')) {
                <p class="m-0">{{ "label-title.email" | translate }} {{ "label-title.is-required" | translate }}</p>
                } @else if (emailInput?.hasError('pattern')) {
                {{ "validation-title.email-is-invalid" | translate }}
                }
              </div>
              }
            </div>
          </div>
          <div class="col-lg-12 phone-code-column">
            <div class="mb-3">
              <label for="user-phone-number" class="form-label">{{ "label-title.phone" | translate }}</label>
              <div class="input-group">
                @if (helper.userCountryPhoneCodeList.length > 1) {
                <ng-select
                  class="user-phone-code-select"
                  appearance="outline"
                  [searchable]="false"
                  [clearable]="false"
                  [(ngModel)]="selectedPhoneCode"
                  [ngModelOptions]="{ standalone: true }"
                  [readonly]="helper.userCountryPhoneCodeList.length == 1"
                  placeholder="{{ 'label-title.code' | translate }}"
                >
                  @for ( phoneCode of helper.userCountryPhoneCodeList; track $index) {
                  <ng-option [value]="phoneCode">
                    <span class="mx-2 countrylist-codeno text-muted">{{ phoneCode }}</span>
                  </ng-option>
                  }
                </ng-select>
                } @else {
                <span class="input-group-text">{{ selectedPhoneCode ?? helper.userCountryPhoneCodeList[0] }}</span>
                }
                <input
                  type="phone"
                  disablePasteDrop
                  class="form-control"
                  id="user-phone-number"
                  placeholder="{{ 'label-title.phone' | translate }}"
                  formControlName="phone"
                  (keypress)="helper.noDecimalNumberValidationPhone($event)"
                  [minlength]="helper.minPhoneNumberLength"
                  [maxlength]="helper.maxPhoneNumberLength"
                />
                @if (phoneInput?.invalid && phoneInput?.touched) {
                <div class="invalid-message">
                  @if (phoneInput?.hasError('required')) {
                  <span>{{ "label-title.phone-number" | translate | titlecase }} {{ "label-title.is-required" | translate }}</span>
                  } @else if (phoneInput?.hasError('minlength')) {
                  <span>{{ "label-title.phone-number" | translate | titlecase }} {{ "label-title.is-too-small" | translate }}</span>
                  } @else if (phoneInput?.hasError('maxlength')) {
                  <span>{{ "label-title.phone-number" | translate | titlecase }} {{ "label-title.is-too-large" | translate }} </span>
                  } @else if (phoneInput?.hasError('pattern')) {
                  <span>{{ "validation-title.phone-is-invalid" | translate }}</span>
                  }
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-12 d-flex justify-content-end">
          <button id="other-user-add-btm" class="btn btn-secondary" (click)="addOtherUser()">
            {{ "button-title.add" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
